import { render } from "./additaments.vue?vue&type=template&id=4b0c8d08"
import script from "./additaments.vue?vue&type=script&lang=js"
export * from "./additaments.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__